import {PositionState} from './position.state';
import {createReducer, on} from '@ngrx/store';
import {PositionActions} from './position.index';

export const positionsFeatureKey = 'positions';

const initialState: PositionState = {
  bmPositions: [],
  isBmLoading: false,
  tlPositions: [],
  isTlLoading: false,
  tpPositions: [],
  isTpLoading: false,
  position: null,
  pmDocuments: []
};

const reducer = createReducer(
  initialState,
  on(PositionActions.LOAD_POSITION, state => state),
  on(
    PositionActions.ON_POSITION_LOADED_SUCCESS,
    (state, action) => ({
      ...state,
      position: action.position
    })
  ),
  on(PositionActions.ON_POSITION_LOADED_ERROR, state => state),
  on(PositionActions.LOAD_TP_POSITIONS, state => ({
    ...state,
    isTpLoading: true
  })),
  on(
    PositionActions.ON_LOAD_TP_POSITIONS_SUCCESS,
    (state, action) => ({
      ...state,
      tpPositions: action.positions,
      isTpLoading: false
    })
  ),
  on(PositionActions.ON_LOAD_TP_POSITIONS_ERROR, state => ({
    ...state,
    isTpLoading: false
  })),
  on(PositionActions.LOAD_BM_POSITIONS, state => ({
    ...state,
    isBmLoading: true
  })),
  on(
    PositionActions.ON_LOAD_BM_POSITIONS_SUCCESS,
    (state, action) => ({
      ...state,
      bmPositions: action.positions,
      isBmLoading: false
    })
  ),
  on(PositionActions.ON_LOAD_BM_POSITIONS_ERROR, state => ({
    ...state,
    isBmLoading: false
  })),
  on(PositionActions.LOAD_TL_POSITIONS, state => ({
    ...state,
    isTlLoading: true
  })),
  on(
    PositionActions.ON_TL_POSITIONS_LOADED_SUCCESS,
    (state, action) => ({
      ...state,
      tlPositions: action.positions,
      isTlLoading: false
    })
  ),
  on(PositionActions.ON_TL_POSITIONS_LOADED_ERROR, state => ({
    ...state,
    isTlLoading: false
  })),
  on(PositionActions.LOAD_PM_DOCUMENTS, state => state),
  on(PositionActions.LOAD_PM_DOCUMENTS_SUCCESS, (state, action) => ({
    ...state,
    pmDocuments: action.documents
  })),
  on(PositionActions.LOAD_PM_DOCUMENTS_ERROR, (state, action) => ({
    ...state,
    action
  }))
);

export function positionsReducer(state: PositionState, action) {
  return reducer(state, action);
}
